import React from 'react';
import { Box, Typography, Grid, Paper, Chip, IconButton } from '@mui/material';
import SettingsIcon from '@mui/icons-material/Settings'; // Asegúrate de tener @mui/icons-material
import BarChartIcon from '@mui/icons-material/BarChart';

const AiDashboard = ({ agentMode, waNumber, isActive }) => {
    
    return (
        <Box sx={{ p: 3 }}>
            {/* Header del Dashboard */}
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 4 }}>
                <Box>
                    <Typography variant="h5" fontWeight="bold">
                        Centro de Operaciones IA
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                        Gestionando: {waNumber || 'Número no registrado'}
                    </Typography>
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                    <Chip 
                        label={isActive ? 'Agente En Línea' : 'Agente Pausado'} 
                        color={isActive ? 'success' : 'default'} 
                        variant="outlined"
                        sx={{ fontWeight: 'bold' }}
                    />
                    <IconButton color="primary">
                        <SettingsIcon />
                    </IconButton>
                </Box>
            </Box>

            {/* Métricas Rápidas */}
            <Grid container spacing={3} sx={{ mb: 4 }}>
                <Grid item xs={12} md={4}>
                    <Paper elevation={1} sx={{ p: 3, borderRadius: 2, borderLeft: '4px solid #1976d2' }}>
                        <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                            Modo Actual
                        </Typography>
                        <Typography variant="h6" fontWeight="bold">
                            {agentMode === 'conversational' ? 'Conversacional Avanzado' : 'Lineal (Menús)'}
                        </Typography>
                    </Paper>
                </Grid>
                <Grid item xs={12} md={4}>
                    <Paper elevation={1} sx={{ p: 3, borderRadius: 2, borderLeft: '4px solid #2e7d32' }}>
                        <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                            Mensajes Procesados (Mes)
                        </Typography>
                        <Typography variant="h4" fontWeight="bold">
                            1,245 {/* Dato Mock */}
                        </Typography>
                    </Paper>
                </Grid>
                <Grid item xs={12} md={4}>
                    <Paper elevation={1} sx={{ p: 3, borderRadius: 2, display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', cursor: 'pointer', '&:hover': { bgcolor: '#f5f5f5' } }}>
                        <Box textAlign="center">
                            <BarChartIcon color="action" fontSize="large" />
                            <Typography variant="subtitle2" color="text.secondary" mt={1}>
                                Ver Estadísticas Detalladas
                            </Typography>
                        </Box>
                    </Paper>
                </Grid>
            </Grid>

            {/* Espacio para el Visor de Chats (Próxima fase) */}
            <Paper elevation={1} sx={{ p: 3, borderRadius: 2, minHeight: 300 }}>
                <Typography variant="h6" fontWeight="bold" gutterBottom>
                    Actividad Reciente
                </Typography>
                <Typography variant="body2" color="text.secondary">
                    El visor de conversaciones en tiempo real se renderizará aquí.
                </Typography>
                {/* Aquí inyectarás el componente de Chat Live posteriormente */}
            </Paper>
        </Box>
    );
};

export default AiDashboard;